import React, { Component } from "react";
import ManualReconcilerRuleSelector from "./manual_reconciler_rule_selector";
import RecommendedReconcilerList from "./recommended_reconciler_list";
import {
  Tooltip,
  Button,
  Row,
  notification,
  Popconfirm,
  Switch,
  Tag,
  Badge,
  Input,
} from "antd";
import { RESTExecutor, withDomains } from "../../lib/domain";
import {
  showErrorInNotification,
  showSuccessInNotification,
} from "../../lib/util";
import { COLORS } from "../theme";
import { SyncAltRounded, PlaylistAddCheckOutlined } from "@material-ui/icons";
import { TransparentButton } from "../../components/basic_items";

export const OURS_KEY = "ours";
export const THEIRS_KEY = "theirs";
class RecommendedMode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // supports manual or recommended or tabular
      reconciler_mode: "Recommended",
      loading: false,
      recommend_for: OURS_KEY,
      selected_our: null,
      selected_our_index: null,
      selected_rule: {},
      selected_their: null,
      selected_their_index: null,
      selected_our_transaction: {},
      selected_their_transaction: {},
    };

    this.reconcile_manually = RESTExecutor.post()
      .config({
        label: "reconcile_manually",
      })
      .forId(this.props.reconciler_id)
      .callbacks(
        (success) => {
          console.log("success", success);
          let next_data_resp = {};

          if (this.state.reconciler_mode === "Manual") {
            console.log("recon mode manual");
            console.log(this);
            if (this.our_manual) {
              try {
                this.our_manual.resetAndRefresh();
              } catch (e) {}
            }
            if (this.their_manual) {
              try {
                this.their_manual.resetAndRefresh();
              } catch (e) {}
            }
          }
          // FOR RECOMMENDED
          else {
            if (this.our_manual) {
              try {
                next_data_resp = this.our_manual.removeWithIndex(
                  this.state.recommend_for == OURS_KEY
                    ? this.state.selected_our_index
                    : this.state.selected_their_index,
                  this.state.recommend_for == OURS_KEY
                    ? this.state.selected_their
                    : this.state.selected_our
                );
                // this.our_manual.resetAndRefresh();
              } catch (e) {}
            }
            if (this.recommen_list) {
              try {
                this.recommen_list.getRecommendation(
                  next_data_resp.next_selected_id
                );
              } catch (e) {}
            }
          }
          this.setState({
            selected_our: next_data_resp.next_selected_id,
            selected_their: null,
            selected_our_index: next_data_resp.next_selected_index,
            selected_rule: next_data_resp.next_selected_rule || {},
            selected_their_index: null,
            selected_our_transaction:
              next_data_resp.next_selected_transaction || {},
            selected_their_transaction: {},
          });
          showSuccessInNotification(success, "Transaction Reconciled");
        },
        (error) => {
          showErrorInNotification(error);
        }
      )
      .connect(props.domains.reconciliation);
  }

  render() {
    const {
      reconciler_mode,
      loading,
      recommend_for,
      selected_our,
      selected_their,
      selected_rule,
      selected_our_transaction,
      selected_their_transaction,
    } = this.state;
    let reconciler_id = this.props.reconciler_id;
    let reconcile_manually_resp = this.reconcile_manually.response();

    let reconciler = this.props.reconciler || {};
    let references = reconciler.__references__ || {};
    let our_datatype = references.our_data_type_id || {};
    let their_datatype = references.their_data_type_id || {};
    let manual_rules = reconciler.manual_rules || {};
    let current_mode = this.props.currentMode;

    // console.log("SHOULD SHOW DIALPG",(!manual_rules.amount_equal) && (selected_our_transaction&&selected_our_transaction.amount&&selected_their_transaction&&selected_their_transaction.amount&&selected_our_transaction.amount!=selected_their_transaction.amount))

    return (
      <React.Fragment>
        <Row
          type="flex"
          justify="space-between"
          style={{
            flexWrap: "nowrap",
            overflowX: "scroll",
            minWidth: 900,
            flex: 1,
          }}
        >
          <ManualReconcilerRuleSelector
            toggleRender={
              <React.Fragment>
                <span className="sub-heading-3">
                  {recommend_for == OURS_KEY ? "OURS" : "THEIRS"}
                </span>
                &nbsp;&nbsp;&nbsp;
                <span
                  className="heading-2"
                  style={{
                    color: COLORS.primary,
                  }}
                >
                  {recommend_for == OURS_KEY
                    ? our_datatype.name
                    : their_datatype.name}
                </span>
                &nbsp;&nbsp;&nbsp;
                <SyncAltRounded
                  onClick={() => {
                    this.setState({
                      recommend_for:
                        recommend_for === OURS_KEY ? THEIRS_KEY : OURS_KEY,
                      selected_our: null,
                      selected_their: null,
                      selected_our_transaction: {},
                      selected_their_transaction: {},
                    });
                  }}
                  titleAccess="Switch OURS and THEIRS"
                  className="toggle-icon hand-cursor"
                />
              </React.Fragment>
            }
            mode={this.props.mode}
            onModeChange={this.props.onModeChange}
            key={`${recommend_for}our`}
            type={recommend_for}
            reconciler_id={reconciler_id}
            source_id={this.props.source_id}
            reconciler={this.props.reconciler}
            selected_rule={selected_rule.rule_id}
            onRuleSelected={(id, data, rule, index) => {
              if (recommend_for === OURS_KEY) {
                this.setState(
                  {
                    selected_our: id,
                    selected_their: null,
                    selected_rule: rule,
                    selected_our_transaction: data,
                    selected_our_index: index,
                  },
                  () => {
                    if (this.recommen_list) {
                      try {
                        this.recommen_list.getRecommendation(id);
                      } catch (e) {
                        console.log("Error in getting recommendation");
                      }
                    }
                  }
                );
              } else {
                this.setState(
                  {
                    selected_their: id,
                    selected_our: null,
                    selected_rule: rule,
                    selected_their_transaction: data,
                    selected_their_index: index,
                  },
                  () => {
                    if (this.recommen_list) {
                      try {
                        this.recommen_list.getRecommendation(id);
                      } catch (e) {
                        console.log("Error in getting recommendation");
                      }
                    }
                  }
                );
              }
            }}
            onSelectedID={(id, data) => {
              if (recommend_for === OURS_KEY) {
                this.setState(
                  {
                    selected_our: id,
                    selected_their: null,
                    selected_our_transaction: data,
                  },
                  () => {
                    if (this.recommen_list) {
                      try {
                        this.recommen_list.getRecommendation(id);
                      } catch (e) {
                        console.log("Error in getting recommendation");
                      }
                    }
                  }
                );
              } else {
                this.setState(
                  {
                    selected_their: id,
                    selected_our: null,
                    selected_their_transaction: data,
                  },
                  () => {
                    if (this.recommen_list) {
                      try {
                        // let transaction_id=recommend_for===OURS_KEY?selected_our:selected_their;
                        this.recommen_list.getRecommendation(id);
                      } catch (e) {
                        console.log("Error in getting recommendation");
                      }
                    }
                  }
                );
              }
            }}
            onRef={(ref) => {
              this.our_manual = ref;
            }}
            // key={`${recommend_for}`}
          />
          <div style={{ width: 30 }}></div>
          <RecommendedReconcilerList
            reconcile_btn={
              <Popconfirm
                title={
                  <div>
                    <label>{`Amount ${
                      selected_our_transaction &&
                      selected_our_transaction.amount
                    } not equal to ${
                      selected_their_transaction &&
                      selected_their_transaction.amount
                    }. Do you want to reconcile?`}</label>
                  </div>
                }
                disabled={
                  !(
                    manual_rules.amount_equal &&
                    selected_our_transaction &&
                    selected_our_transaction.amount &&
                    selected_their_transaction &&
                    selected_their_transaction.amount &&
                    selected_our_transaction.amount !=
                      selected_their_transaction.amount
                  )
                }
                onConfirm={() => {
                  this.reconcile_manually
                    .forId(this.props.reconciler_id)
                    .execute({
                      our_id: String(selected_our),
                      their_id: String(selected_their),
                      source_id: this.props.source_id,
                    });
                }}
              >
                <TransparentButton
                  disabled={
                    !(selected_our && selected_their) ||
                    reconcile_manually_resp.fetching
                  }
                  className="cta-reconcile"
                  onClick={() => {
                    if (
                      !(
                        manual_rules.amount_equal &&
                        selected_our_transaction &&
                        selected_our_transaction.amount &&
                        selected_their_transaction &&
                        selected_their_transaction.amount &&
                        selected_our_transaction.amount !=
                          selected_their_transaction.amount
                      )
                    ) {
                      this.reconcile_manually
                        .forId(this.props.reconciler_id)
                        .execute({
                          our_id: String(selected_our),
                          their_id: String(selected_their),
                          source_id: this.props.source_id,
                        });
                    }
                  }}
                  icon={<PlaylistAddCheckOutlined />}
                  label="RECONCILE"
                />
              </Popconfirm>
            }
            onReconcile={
              !(selected_our && selected_their) ||
              reconcile_manually_resp.fetching
                ? null
                : () => {}
            }
            toggleRender={
              <React.Fragment>
                <span className="sub-heading-3">
                  {recommend_for != OURS_KEY ? "OURS" : "THEIRS"}
                </span>
                &nbsp;&nbsp;&nbsp;
                <span
                  className="heading-2"
                  style={{
                    color: COLORS.primary,
                  }}
                >
                  {recommend_for != OURS_KEY
                    ? our_datatype.name
                    : their_datatype.name}
                </span>
                &nbsp;&nbsp;&nbsp;
                <SyncAltRounded
                  onClick={() => {
                    this.setState({
                      recommend_for:
                        recommend_for === OURS_KEY ? THEIRS_KEY : OURS_KEY,
                      selected_our: null,
                      selected_their: null,
                      selected_our_transaction: {},
                      selected_their_transaction: {},
                    });
                  }}
                  titleAccess="Switch OURS and THEIRS"
                  className="toggle-icon hand-cursor"
                />
              </React.Fragment>
            }
            currentMode={this.props.currentMode}
            onToggle={this.props.onToggle}
            rule_id={selected_rule.rule_id}
            reconciler_id={this.props.reconciler_id}
            source_id={this.props.source_id}
            reconciler={this.props.reconciler}
            key={`${recommend_for}--`}
            onRef={(ref) => {
              this.recommen_list = ref;
            }}
            onSelectedID={(id, data) => {
              if (recommend_for === THEIRS_KEY) {
                this.setState({
                  selected_our: id,
                  selected_our_transaction: data,
                });
              } else {
                this.setState({
                  selected_their: id,
                  selected_their_transaction: data,
                });
              }
            }}
            type={recommend_for}
            // tran_id={recommend_for===OURS_KEY?selected_their:selected_our}
          />
        </Row>
      </React.Fragment>
    );
  }
}

export default withDomains(RecommendedMode, "reconciliation");
